import { takeLatest, put, call, takeEvery } from "redux-saga/effects";
import { axiosInstance, apiURL } from "config";
import toast from "react-hot-toast";

import {
  loadCategoriesRequested,
  loadCategoriesSuccess,
  loadCategoriesFail,
  storeCategoryRequested,
  storeCategorySuccess,
  storeCategoryFail,
  updateCategoryRequested,
  updateCategorySuccess,
  updateCategoryFail,
  storeSubCategoryRequested,
  storeSubCategorySuccess,
  storeSubCategoryFail,
  archiveCategoryFail,
  archiveCategoryRequested,
  archiveCategorySuccess,
  archiveSubCategoryFail,
  archiveSubCategoryRequested,
  archiveSubCategorySuccess,
  updateSubCategoryRequested,
  updateSubCategorySuccess,
  updateSubCategoryFail,
  loadNonPaginatedCategoriesSuccess,
  loadNonPaginatedCategoriesFail,
  loadNonPaginatedCategoriesRequested,
  loadNonPaginatedSubCategoriesRequested,
  loadNonPaginatedSubCategoriesSuccess,
  loadNonPaginatedSubCategoriesFail,
  loadSubCategoriesByCategoriesFail,
  loadSubCategoriesByCategoriesRequested,
  loadSubCategoriesByCategoriesSuccess,
} from "./categoriesSlice";
import { useSelector } from "react-redux";
import { RootState } from "store/reducer";

export function* loadCategoriesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/index-category?searchString=${
        action?.payload?.filters?.query ?? ""
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`
    );
    yield put(loadCategoriesSuccess(data));
  } catch (error: any) {
    yield put(loadCategoriesFail(error.message));
  }
}

export function* deleteCategoryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {

    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delete-category?Id=${action.payload?.item?.id}`
    );
    if (data?.succeeded) {
      yield put(archiveCategorySuccess(data));
      yield call(loadCategoriesEffect, {
        payload: {
          page: action?.payload?.page,
          perPage: action?.payload?.perPage,
          filters: {
            category: {
              id: action?.payload?.filter,
            },
          },
        },
        type: '',
      });
      toast.success("Category deleted successfully");
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(archiveCategoryFail(error.message));
  }
}

export function* storeCategoryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/create-category`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeCategorySuccess(data));
      toast.success("Category created successfully");
      window.location.href = ".";
    } else {
      toast.error("Category create failed! ", data?.errors);
    }
  } catch (error: any) {
    yield put(storeCategoryFail(error.message));
  }
}

export function* storeSubCategoryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/create-sub-category`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeSubCategorySuccess(data));
      yield call(loadCategoriesEffect, {
        payload: { page: 1, perPage: 10 },
        type: "",
      });
      toast.success("Subcategory created successfully");
    } else {
      toast.error("Subcategory create failed! ", data?.errors);
    }
  } catch (error: any) {
    yield put(storeSubCategoryFail(error.message));
  }
}

export function* deleteSubCategoryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delete-sub-category?Id=${action.payload?.id}`
    );
    if (data?.succeeded) {
      yield put(archiveSubCategorySuccess(data));
      toast.success("Subcategory deleted successfully");
      yield call(loadCategoriesEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: "",
      });
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(archiveSubCategoryFail(error.message));
  }
}

function* updateCategoryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/edit-category`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(updateCategorySuccess(data));

      yield call(loadCategoriesEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: "",
      });
      toast.success("Category updated successfully");
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(updateCategoryFail(error.message));
  }
}

function* updateSubCategoryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/edit-sub-category`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(updateSubCategorySuccess(data));
      yield call(loadCategoriesEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: "",
      });
      toast.success("Subcategory updated successfully");
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(updateSubCategoryFail(error.message));
  }
}

export function* loadNonPaginatedCategoriesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(axiosInstance.get, `${apiURL}/get-categories`);
    yield put(loadNonPaginatedCategoriesSuccess(data));
  } catch (error: any) {
    yield put(loadNonPaginatedCategoriesFail(error.message));
  }
}

export function* loadNonPaginatedSubCategoriesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-sub-categories`,
      action.payload
    );
    yield put(loadNonPaginatedSubCategoriesSuccess(data));
  } catch (error: any) {
    yield put(loadNonPaginatedSubCategoriesFail(error.message));
  }
}

export function* loadSubCategoriesByCategoryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/get-subcategory-by-category-ids`,
      action.payload
    );
    yield put(loadSubCategoriesByCategoriesSuccess(data));
  } catch (error: any) {
    yield put(loadSubCategoriesByCategoriesFail(error.message));
  }
}

export function* categoriesSaga(): Generator<any, void, any> {
  yield takeEvery(loadCategoriesRequested, loadCategoriesEffect);
  yield takeEvery(storeCategoryRequested, storeCategoryEffect);
  yield takeEvery(storeSubCategoryRequested, storeSubCategoryEffect);
  yield takeLatest(updateCategoryRequested, updateCategoryEffect);
  yield takeLatest(updateSubCategoryRequested, updateSubCategoryEffect);
  yield takeLatest(archiveSubCategoryRequested, deleteSubCategoryEffect);
  yield takeLatest(archiveCategoryRequested, deleteCategoryEffect);

  yield takeEvery(
    loadNonPaginatedCategoriesRequested,
    loadNonPaginatedCategoriesEffect
  );
  yield takeEvery(
    loadNonPaginatedSubCategoriesRequested,
    loadNonPaginatedSubCategoriesEffect
  );

  yield takeEvery(
    loadSubCategoriesByCategoriesRequested,
    loadSubCategoriesByCategoryEffect
  );
}
